// extracted by mini-css-extract-plugin
export default {"choose-path-modal":"g__choose-path-modal--MdEjG","modal-title":"g__modal-title--B409I","modal-logo":"g__modal-logo--IRkt4","choose-path":"g__choose-path--DOpMw"};